import request from '@/utils/request'

export function dataGet (url, data) {
  return request({
    method: 'get',
    url,
    data
  })
}

export function dataGetUrl (url) {
  return request({
    method: 'get',
    url
  })
}

export function dataPost (url, data) {
  return request({
    url,
    method: 'post',
    data
  })
}
// 获取数据字典管理员
export function getdists (sendcode) {
  return request({
    url: '/qcx/util/dists',
    method: 'post',
    params: {code: sendcode}
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js